<template>
    <div class="container">
        
      <br>
      <br>

       <b-tabs v-model="activeTab"  size="is-large" class="block">
            <b-tab-item label="User">

                 <table class="table">
                        <tbody>
                            <tr>
                                <td><b-button type="is-success is-light"  size="is-medium"   @click="userManagement">User Management</b-button></td>
                                <td><b-button type="is-success is-light"  size="is-medium"   @click="showAuthGroup">Auth. Group</b-button></td>
                                <td><b-button type="is-success is-light"  size="is-medium"   @click="showAuthGrant"  >Auth. Grant</b-button></td>
                            </tr>
                        </tbody>
                        </table>




            </b-tab-item>

            <b-tab-item label="Etc.">
                 <table class="table">
                        <tbody>
                            <tr>
                                <td><b-button type="is-success is-light"  size="is-medium"   @click="nonAutomateCombosetManagement">NonAutomate Comboset Management(For VR)</b-button></td>
                                <td><b-button type="is-success is-light"  size="is-medium"   @click="warningWhenLabUnpublish">Warning When Lab Unpublish</b-button></td>
                                <td><b-button type="is-success is-light"  size="is-medium"   @click="disableReasonManagement">  Disable Reason Management</b-button></td>
                            </tr>

                            <tr>
                                <td><b-button type="is-success is-light"  size="is-medium"   @click="disableReport"> Disable Report </b-button></td>
                                <td><b-button type="is-success is-light"  size="is-medium"   @click="deleteOrderReasonManagement"> DeleteOrder Reason Management </b-button></td>
                                <td><b-button type="is-success is-light"  size="is-medium"   @click="showWebLog"> Web Log </b-button></td>
                            </tr>

                            <tr>
                              <td><b-button type="is-success is-light"  size="is-medium"   @click="differentialCounterLog"> Differential Counter Log </b-button>  </td>
                              <!--                                <td><b-button type="is-success is-light"  size="is-medium"   @click="showWebLog1"> Web Log 1  </b-button></td> -->
                                <td><b-button type="is-success is-light"  size="is-medium"   @click="showDxCodeManage">  Dx Code Management  </b-button></td>
                                <td><b-button type="is-success is-light"  size="is-medium"   @click="showDashboardLabNonStatus">  Dashboard Status Lab Non Automate </b-button></td>
                            </tr>


                            <tr>
                                <td><b-button type="is-success is-light"  size="is-medium"   @click="showBactDataMst"> Bacterial Data Master  </b-button></td>
                                <td><b-button type="is-success is-light"  size="is-medium"   @click="showOrgaDataMst"> Orga Data Master  </b-button> </td>
                                <td><b-button type="is-success is-light"  size="is-medium"   @click="showResultPCRMange"> Result PCR Management  </b-button></td>
                            </tr>

                            <tr>
                                <td><b-button type="is-success is-light"  size="is-medium"   @click="showParasiteDataMst"> Parasite Data Master  </b-button></td>
                                <td><b-button type="is-success is-light"  size="is-medium"   @click="pathoCombosetManagementNonAutomate(0)"> Patho Comboset Management (Nonautomate) </b-button>  </td>
                                <td><b-button type="is-success is-light"  size="is-medium"   @click="pathoCombosetManagementNonAutomate(1)"> Patho Comboset Management (Automate) </b-button>   </td>
                            </tr>


                            <tr>
                                <td><b-button type="is-success is-light"  size="is-medium"   @click="pathoItemsManagement"> Patho Items </b-button></td>
                                <td> </td>
                                <td> </td>
                            </tr>




                        </tbody>
                        </table>
            </b-tab-item>



             <b-tab-item label="Report">

                 <table class="table">
                        <tbody>
                            <tr>
                                <td><b-button type="is-success is-light"  size="is-medium"   @click="showReportL01"> ReportL01 </b-button></td>
                                <td><b-button type="is-success is-light"  size="is-medium"   @click="showReportL0203"> ReportL02 &&  ReportL03 </b-button> </td>
                                <td> </td>
                            </tr>
                        </tbody>
                        </table>




            </b-tab-item>


            <b-tab-item label="Parameter">

                 <table class="table">
                        <tbody>
                            <tr>
                                <td><b-button type="is-success is-light"  size="is-medium"   @click="showBloodMorphology_Mgr"> Blood morphology </b-button></td>
                                <td><b-button type="is-success is-light"  size="is-medium"   @click="showBloodParasite_Mgr"> Blood Parasite  </b-button>  </td>
                                <td><b-button type="is-success is-light"  size="is-medium"   @click="showUADashboard"> UA Manager (Cast,Epith,Cystal)  </b-button>  </td>
                                <td><b-button type="is-success is-light"  size="is-medium"   @click="showUADashboard1"> UA Manager (Color,Technique,Transparent)  </b-button>  </td>
                            </tr>

                             
                        </tbody>
                        </table>




            </b-tab-item>





 

         
        </b-tabs>
 

      <UserManagement   
        v-if="isUserManagement" 
        :isComponentModalActive="isUserManagement" 
        @closeUserManagement="closeUserManagement"/>


 

      <AuthGroup ref="AuthGroup"/>
      <AuthGrant ref="AuthGrant"/>
      <GroupNonAutomateReqManagement ref="GroupNonAutomateReqManagement"/>
      <PathoCombosetManagement ref="PathoCombosetManagement" :kindProps="kindProps" />  
      <WarningLabUnPublish ref="WarningLabUnPublish" />
      <DisableReasonManagement ref="DisableReasonManagement" />
      <ReportDisabled   ref="ReportDisabled"/>
      <DeleteOrderReasonManagement ref="DeleteOrderReasonManagement"/>
      <WebLog ref="WebLog" @closeModalWebLog="closeModalWebLog" /> 
      <WebLog1 ref="WebLog1" @closeModalWebLog1="closeModalWebLog1" /> 
      
      <PCRPathogenDashboard
        v-if="isResultPCRManageShowing"
        :isComponentModalActive = "isResultPCRManageShowing"
        @close="closeResultPCRMange"
        />  

      <DxCodeManagement
        v-if="isDxCodeManageShowing"
       :isComponentModalActive = "isDxCodeManageShowing"
        @close="closeDxCodeManagement"
       />  


      <DashboardLabNonStatus
            v-if="isDashboardLabNonStatusShowing"
            :isComponentModalActive = "isDashboardLabNonStatusShowing"
            @close = "closeDashboardLabNonStatus"
        />


      <BactDataMst
            v-if="isBactDataMstShowing"
            :isComponentModalActive = "isBactDataMstShowing"
            @closeBactDataMst = "closeBactDataMst"
      /> 


      <OrgaDataMst
            v-if="isOrgaDataMstShowing"
            :isComponentModalActive = "isOrgaDataMstShowing"
            @closeOrgaDataMst = "closeOrgaDataMst"
      /> 


      <ParasiteDataMst
            v-if="isParasiteDataMstShowing"
            :isComponentModalActive = "isParasiteDataMstShowing"
            @closeParasiteDataMst = "closeParasiteDataMst"
      /> 



        <!-- <ReportA001  ref="ReportA001"    /> -->

          <b-modal
                v-if="isReportL01Showing"
                v-model="isReportL01Showing"
                has-modal-card
                full-screen
               >

            <ReportL01
                    v-if="isReportL01Showing"
                    :isShowing = "isReportL01Showing"
                    @close="closeReportL01"
            />
        </b-modal>



         <b-modal
                v-if="isReportL0203Showing"
                v-model="isReportL0203Showing"
                has-modal-card
                full-screen
               >

            <ReportL0203
                    v-if="isReportL0203Showing"
                    :isShowing = "isReportL0203Showing"
                    @close="closeReportL0203"
            />
        </b-modal>



          <b-modal
                v-if="isShowBloodMorphology_Mgr"
                v-model="isShowBloodMorphology_Mgr"
                has-modal-card
                full-screen
               >

            <BloodMorphologyMgr
                    v-if="isShowBloodMorphology_Mgr"
                    :isShowing = "isShowBloodMorphology_Mgr"
                    @close="closeBloodMorphologyMgr"
            />
        </b-modal>



          <b-modal
                v-if="isShowBloodParasite_Mgr"
                v-model="isShowBloodParasite_Mgr"
                has-modal-card
                full-screen
               >
            <BloodParasiteDashboard
                    v-if="isShowBloodParasite_Mgr"
                    :isComponentModalActive = "isShowBloodParasite_Mgr"
                    @close="closeBloodParasite_Mgr"
            />
        </b-modal>




        <b-modal
                v-if="isShowUADashboard"
                v-model="isShowUADashboard"
                has-modal-card
                full-screen
               >
            <UADashboard
                    v-if="isShowUADashboard"
                    :isComponentModalActive = "isShowUADashboard"
                    @close="closeUADashboard"
            />
        </b-modal>




        <b-modal
                v-if="isShowUADashboard1"
                v-model="isShowUADashboard1"
                has-modal-card
                full-screen
               >
            <UADashboard1
                    v-if="isShowUADashboard1"
                    :isComponentModalActive = "isShowUADashboard1"
                    @close="closeUADashboard1"
            />
        </b-modal>








         <!-- <b-modal
                v-if="isSettingParamRefUnitCBC"
                v-model="isSettingParamRefUnitCBC"
                has-modal-card
                full-screen
               >

            <SettingParamRefUnitCBC
                    v-if="isSettingParamRefUnitCBC"
                    :isComponentModalActive = "isSettingParamRefUnitCBC"
                    @close="closeSettingParamRefUnitCBC"
            />
        </b-modal> -->

        





    </div>
</template>





<script>
import UserManagement from "../../Users/UserManagement.vue";
import AuthGroup from "../../Users/AuthGroup.vue";
import AuthGrant from "../../Users/AuthGrant";
import GroupNonAutomateReqManagement from "../../Admin/GroupNonAutomateReqManagement";
import WarningLabUnPublish from "../../Admin/WarningLabUnPublish/WarningLabUnPublish";
import DisableReasonManagement from "../../Admin/DisableReason/DisableReasonManagement";
import ReportDisabled from   "../../Admin/Reports/ReportDisabled";
import DeleteOrderReasonManagement from "../../Admin/DeleteOrderReason/DeleteOrderReasonManagement";
import WebLog from "../../Admin/WebLog";
import WebLog1 from "../../Admin/WebLog1";
import PCRPathogenDashboard from "../../Admin/PCR/PCRPathogenDashboard";
import DxCodeManagement from "../../Admin/DxCode/DxCodeManagement";
import DashboardLabNonStatus from "../../Admin/DashboardLabNonStatus/DashboardLabNonStatus";
import BactDataMst from "../../Admin/Bact/BactDataMst";
import OrgaDataMst from "../../Admin/Orga/OrgaDataMst";
import ParasiteDataMst from "../../Admin/Parasite/ParasiteDataMst";   
import ReportL01 from "../../Admin/Reports/ReportL01";
import ReportL0203 from "../../Admin/Reports/ReportL0203";
import BloodMorphologyMgr from '../BloodMorphology/BloodMorphologyMgr.vue'
import BloodParasiteDashboard from '../BloodParasite/BloodParasiteDashboard.vue'
// import SettingParamRefUnitCBC from '../SettingParamRefUnitCBC/SettingParamRefUnitCBC.vue'
import PathoCombosetManagement from "../../Admin/PathoCombosetManagement/PathoCombosetManagement";
import UADashboard from '../../Admin/UA/UADashboard.vue'
import UADashboard1 from '../../Admin/UA/UADashboard1.vue'

export default {
    name : "MainAdmin",
    components:{
       UserManagement ,
       AuthGroup ,
       AuthGrant  ,
       GroupNonAutomateReqManagement,
       WarningLabUnPublish,
       DisableReasonManagement,
       ReportDisabled,
       DeleteOrderReasonManagement ,
       WebLog,
       WebLog1,
       PCRPathogenDashboard,
       DxCodeManagement,
       DashboardLabNonStatus,
       BactDataMst,
       OrgaDataMst,
       ParasiteDataMst,
    //    ReportA001,
       ReportL01,
       ReportL0203 ,

       BloodMorphologyMgr,
       BloodParasiteDashboard,

    //    SettingParamRefUnitCBC,
       PathoCombosetManagement,
       UADashboard,
       UADashboard1 ,
    },
    methods:{
        closeUADashboard(){
           this.isShowUADashboard = false 
        },
        closeUADashboard1(){
           this.isShowUADashboard1 = false 
        },


        showUADashboard(){
           this.isShowUADashboard = true 
        },
        showUADashboard1(){
           this.isShowUADashboard1 = true  
        },

        differentialCounterLog(){
         this.$router.push('/differentialcounterlog')    
        },  

        pathoItemsManagement(){
         this.$router.push('/pathoitemsmanagement')    
        },
        pathoCombosetManagementNonAutomate(kind){
            //  console.log(kind)
            //   this.$router.push('/patho_comboset_management')
            //  this.$refs.kind  =  kind  
             this.kindProps = kind
            // this.$refs.PathoCombosetManagement.doFetchGroupPathoComboset()
             this.$refs.PathoCombosetManagement.isComponentModalActive = true
         
     
        },

        //*****************************************************************/
        closeParasiteDataMst(){
          this.isParasiteDataMstShowing = false
        },
        showParasiteDataMst(){
          this.isParasiteDataMstShowing = true
        },



        //*****************************************************************/
        showSettingParamRefUnitCBC(){
             this.isSettingParamRefUnitCBC = true
        },
        closeSettingParamRefUnitCBC(){
             this.isSettingParamRefUnitCBC = false
        },


        //*****************************************************************/
        closeBloodParasite_Mgr(){
           this.isShowBloodParasite_Mgr = false
        }, 
        showBloodParasite_Mgr(){
           this.isShowBloodParasite_Mgr = true
        },  
        //*****************************************************************/
        closeBloodMorphologyMgr(){
             this.isShowBloodMorphology_Mgr = false
        },
        showBloodMorphology_Mgr(){
             this.isShowBloodMorphology_Mgr = true
        },





        closeReportL0203(){
            this.isReportL0203Showing = false 
        },
        showReportL0203(){
            this.isReportL0203Showing = true
        },


        // ************************************************************************************************* 
        closeReportL01(){
            this.isReportL01Showing = false 
        },
        showReportL01(){
            this.isReportL01Showing = true
        },
        // ************************************************************************************************* 
        closeOrgaDataMst(){
            this.isOrgaDataMstShowing = false
        },
        showOrgaDataMst(){
            this.isOrgaDataMstShowing = true
        },
        // ************************************************************************************************* 
        closeBactDataMst(){
            this.isBactDataMstShowing = false
        },
        showBactDataMst(){
            this.isBactDataMstShowing = true
        },
        // *************************************************************************************************
        closeDashboardLabNonStatus(){
            this.isDashboardLabNonStatusShowing = false
        },
        showDashboardLabNonStatus(){
           this.isDashboardLabNonStatusShowing = true
        },
        // *************************************************************************************************
        closeDxCodeManagement(){
            this.isDxCodeManageShowing  = false
        },
        showDxCodeManage(){
            this.isDxCodeManageShowing  = true
        },
        // *************************************************************************************************
        closeResultPCRMange(){
            this.isResultPCRManageShowing = false
        },
        showResultPCRMange(){
            this.isResultPCRManageShowing = true

        },
        closeModalWebLog(){
            this.$refs.WebLog.isComponentModalActive = false
        },  
        closeModalWebLog1(){
            this.$refs.WebLog1.isComponentModalActive = false
        },
        showWebLog1(){
            this.$refs.WebLog1.isComponentModalActive = true
        },     
        showWebLog(){
            this.$refs.WebLog.loadCurrentDate()
            this.$refs.WebLog.isComponentModalActive = true
        },
        deleteOrderReasonManagement(){
            this.$refs.DeleteOrderReasonManagement.loadData()
            this.$refs.DeleteOrderReasonManagement.isComponentModalActive = true
        },
        disableReport(){
            this.$refs.ReportDisabled.loadCurrentDate(2)
            this.$refs.ReportDisabled.isComponentModalActive = true  
        },
        disableReasonManagement(){
            this.$refs.DisableReasonManagement.loadData()
            this.$refs.DisableReasonManagement.isComponentModalActive = true
        },
        warningWhenLabUnpublish(){
            this.$refs.WarningLabUnPublish.init()
            this.$refs.WarningLabUnPublish.isComponentModalActive = true
        },
        nonAutomateCombosetManagement(){
             this.$refs.GroupNonAutomateReqManagement.doFetchGroupNonautomateRequest()
             this.$refs.GroupNonAutomateReqManagement.isComponentModalActive = true
         
        },
        // ********************************************************************************
        showAuthGrant(){
            this.$refs.AuthGrant.isComponentModalActive = true  
        },
        // ********************************************************************************
        showAuthGroup(){
           // console.log("showAuthGroup")
            this.$refs.AuthGroup.isComponentModalActive = true
        },
        // ********************************************************************************
        closeUserManagement(){
           this.isUserManagement = false   
        },
        userManagement(){
           this.isUserManagement = true
        },
       


        




    },
    data(){
        return{
            activeTab: 0,
            isUserManagement : false,

            isResultPCRManageShowing : false ,
            isDxCodeManageShowing : false,
            isDashboardLabNonStatusShowing : false,
            isBactDataMstShowing : false,
            isOrgaDataMstShowing : false,
            isParasiteDataMstShowing : false,

            isReportL01Showing : false,
            isReportL0203Showing : false,

            isShowBloodMorphology_Mgr : false,
            isShowBloodParasite_Mgr : false,
            isShowUADashboard : false,
            isShowUADashboard1 : false,

            isSettingParamRefUnitCBC : false,

            kindProps : 0 , // 0 == nonautomate , 1 == automate
      
        }
    }
}
</script>